import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from './CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.zv(parentContext.yc(Key_instance));
        }
        this.cw_1 = parentContext.rm(this);
      }
      mc() {
        return this.cw_1;
      }
      dw() {
        return this.cw_1;
      }
      ew() {
        return super.ew();
      }
      fw(value) {
      }
      gw(cause, handled) {
      }
      hw() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      iw(state) {
        if (state instanceof CompletedExceptionally()) {
          this.gw(state.jw_1, state.lw());
        } else {
          this.fw(state);
        }
      }
      oc(result) {
        var state = this.mw(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.nw(state);
      }
      nw(state) {
        return this.ow(state);
      }
      pw(exception) {
        handleCoroutineException(this.cw_1, exception);
      }
      qw() {
        var tmp0_elvis_lhs = get_coroutineName(this.cw_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.qw();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.qw();
      }
      rw(start, receiver, block) {
        start.uw(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [Job(), Continuation(), CoroutineScope()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
